import React, { memo } from "react";
import { MenuEntry, RankingList, SeekMenu, ShareMenu } from "./common";
import { useQuery } from "react-query";
import { fetchBuyCarMenuPolymer } from "@Services/buyCarMenu";
import { IBuyCarMenuPolymer } from "@Types/buyCarMenu";
import AdIframeImage from "@Components/ad/AdFrame_v2";
import loadable from "@loadable/component";

const AwaitBrandServer = loadable(() => import("./common").then(module => ({ default: module.AwaitBrandServer })));
const JoinMarket = loadable(() => import("./common").then(module => ({ default: module.JoinMarket })));

const RightList: React.FC<any> = () => {
  const initData: IBuyCarMenuPolymer = {
    hotMenuKindRank: [],
    inquiryCount: 0,
    latest3MonthAgents: 0,
    seekMenuCount: 0,
    shareMenuCount: 0,
    unfinishedUsers: 0,
    waitingServiceKindRank: [],
  };

  const showOld = false;
  const showNew = true;

  const { data = initData } = useQuery<IBuyCarMenuPolymer>([`fetchBuyCarMenuPolymer`], async () => {
    const res = await fetchBuyCarMenuPolymer();
    return res?.status === 12000 ? res.data : initData;
  });

  const {
    inquiryCount,
    shareMenuCount,
    seekMenuCount,
    unfinishedUsers,
    hotMenuKindRank,
    waitingServiceKindRank,
    latest3MonthAgents,
  } = data;
  return (
    <div className='w-240'>
      {/* 右側橫幅廣告 */}
      {/* <AdRight slot='/173427088/newcar-pc-menu-right' /> */}
      <div className='relative'>
        <AdIframeImage
          slot={"/173427088/newcar-pc-menu-right"}
          size={[["fluid"], [240, 200]]}
          width={240}
          height={200}
          imgStyles={{
            borderRadius: "4px"
          }}
          styles={{
            marginBottom: "20px",
          }}
        />
      </div>
      {showNew && (
        <MenuEntry inquiryCount={inquiryCount} shareMenuCount={shareMenuCount} source='購車菜單-右側徵求菜單' />
      )}
      {showOld && (
        <>
          {/* 分享模塊 */}
          <ShareMenu inquiryCount={inquiryCount} shareMenuCount={shareMenuCount} />
          {/* 征求模塊 */}
          <SeekMenu seekMenuCount={seekMenuCount} source='購車菜單-右側徵求菜單' />
        </>
      )}

      {/* 優質菜單排行 */}
      <RankingList hotMenuKindRank={hotMenuKindRank} />
      {/* 待服務的前十廠牌 */}
      <AwaitBrandServer waitingServiceKindRank={waitingServiceKindRank} latest3MonthAgents={latest3MonthAgents} />
      {/* 加入業代 */}
      <JoinMarket unfinishedUsers={unfinishedUsers} />
    </div>
  );
};
export default memo(RightList);
